export default __webpack_public_path__ + "static/media/img_gas_phase_05.4f8df441.png";